<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @close="alertContent=''"/>
    <div id="user-bills">
        <div class="container table-responsive">
            <table class="table table-hover table-borderless">
                <thead>
                <tr>
                    <th class="th-first-reduce">ردیف</th>
                    <th>عنوان</th>
                    <th>تاریخ</th>
                    <th>مبلغ</th>
                    <th>وضعیت</th>
                    <th>عملیلت</th>
                    <th class="th-last-reduce"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(bill , index) in bills" class="data-container" :key="bill">
                    <td>{{index+1}}</td>
                    <td>{{bill.title}}</td>
                    <td>{{bill.created_at}}</td>
                    <td>{{bill.amount}} تومان</td>
                    <td v-if="bill.status ==0">در انتظار پرداخت</td>
                    <td v-else class="payment-status-payed">پرداخت شده</td>
                    <td :class="{'payment-event-payed' : bill.status ==1}">
                        <a v-if="bill.status ==0" class="a-tag" v-on:click="paymentConnection(bill.code)">پرداخت</a>
                        <a v-else>پرداخت</a>
                    </td>
                    <td>
                        <a :href="$store.state.base_urls.officialUploads + bill.file_name"> مشاهده صورتحساب</a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

     <PanelLoader v-if="loadingMood"/>

</template>

<script>
    import axios from 'axios'
    import Alert from "../../components/Alert"
    import PanelLoader from "../../components/PanelLoader"
    export default {
        name: "UserBills",
        data(){
            return {
                bills:{},
                alertContent:null,
                loadingMood:false,
            }
        },
        components:{
            Alert,
            PanelLoader
        },
        methods:{
            async getData(){
                try {
                    this.loadingMood=true;
                    const response = await axios.get('api/userDashboard/clientBills',{headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}});
                    this.loadingMood=false;
                    this.bills  = response.data.bills;
                } catch (error) {
                    this.loadingMood=false;
                    this.alertContent={
                        message: 'خطا در انجام عملیات!',
                        imageUrl:require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType:'close',//close
                        buttonText:'تایید',
                        buttonLink:'',///personal-info
                        waitingMode:false
                    };
                }
            },
            async handelSubmit() {
                try {
                    this.loadingMood=true;
                    let response =  await axios.post('api/userDashboard/personalInfoEdit' ,{data:this.data},{headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}});
                    this.loadingMood=false;
                    this.alertContent={
                        message: 'اطلاعات کاربری شما با موفقیت ذخیره شد!',
                        imageUrl:require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType:'close',//close
                        buttonText:'تایید',
                        buttonLink:'',
                        waitingMode:false
                    };
                    console.log(response);
                }
                catch (error) {
                    this.loadingMood=false;
                    console.log(error.response.data.status);
                    if(error.response.data.status=='repetitive_save_request'){
                        this.alertContent={
                            message: 'خطا در انجام عملیات!',
                            notice:error.response.data.errors,
                            imageUrl:require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                            buttonType: 'link',
                            buttonText: 'ورود به داشبورد',
                            buttonLink: '/user-panel',
                            closeButtonShow:true,
                            waitingMode:false
                        };
                    }else{
                        this.alertContent={
                            message: 'خطا در انجام عملیات!',
                            notice:error.response.data.errors,
                            imageUrl:require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                            buttonType : 'close',
                            buttonText : 'تایید',
                            buttonLink : '',
                            closeButtonShow:true,
                            waitingMode:false
                        };
                    }

                }
            },
            async paymentConnection(code){
                try {
                    this.loadingMood=true;
                    let response =  await axios.get('api/userDashboard/paymentConnection/'+code,{headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}});
                    this.loadingMood=false;
                    window.location.href = response.data.action;
                }
                catch (error) {
                    this.loadingMood=false;
                        this.alertContent={
                            message: 'خطا در انجام عملیات!',
                            notice:error.response.data.errors,
                            imageUrl:require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                            buttonType : 'close',
                            buttonText : 'تایید',
                            buttonLink : '',
                            closeButtonShow:true,
                            waitingMode:false
                        };
                }
            },
        },

        updated() {},
        created(){
            this.getData();
        }
    }
</script>

<style lang="scss" scoped>
    .a-tag{
        cursor: pointer!important;
        color: #162336!important;
    }
    .a-tag:hover{
        color: #fe7063!important;
        text-decoration: underline!important;
    }
    table{
        min-width: max-content!important;
        width: 100%;
        margin: auto;
    }
    .payment-status-payed{
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #4ad41a;
    }
    .payment-event-payed{
        color: #e3e3e3;
    }

    .data-container{
        cursor: pointer;
        border-bottom: 1px solid #e3e3e3!important;
    }
    th , td {
        text-align: center;
    }
    td{
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #162336;
    }

    .th-first-reduce{
        border-top-right-radius:10px;
        border-bottom-right-radius:10px;
    }
    .th-last-reduce{
        border-top-left-radius:10px;
        border-bottom-left-radius:10px;
    }
    table{
        thead{
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: right;
            color: #162336;
            background-color: rgba(232,232,232,0.5)
        }
    }

    #user-bills{
        width: 100%;
        height: 100%;
        padding: 30px;
    }
</style>